<section class="page-title-area">
    <div class="container">
        <div
            class="page-title-content text-center"
            *ngFor="let pageTitle of pageTitleArea"
        >
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="projects-area pt-0 pb-70">
    <div class="container">
        <div class="row" *ngIf="this.pageData === 'data-foundation'">
            <div class="col-lg-12 col-md-6">
                <p>
                    The Upstream Data Foundation (UDF) is both an aspirational
                    architectural conceptual target for the unified, governed
                    view of ExxonMobil's Upstream data as well as an
                    organization in Upstream Digital responsible for stewarding
                    the foundation's ongoing architectural and governance
                    efforts.
                </p>
                <ol style="color: var(--optionalColor)">
                    <li>
                        The overall recommendation for the Upstream Data
                        Foundation is to adopt a formal hub-and-spoke conceptual
                        architecture.
                    </li>
                    <li>
                        Limiting the number of Upstream data hubs to the
                        currently known set of Kepler, UDA, MOP, OSDU/DELFI
                        OpenDEC, FTP (EDH/FEDNED) is recommended. Consolidation
                        is permissible if desired. Justification for
                        consolidation is not immediately obvious but is a
                        testable hypothesis.
                    </li>
                    <li>
                        Products not listed in Recommendation 2 above are, by
                        exclusion, not considered Upstream hubs. Where
                        applications are in contradiction with Recommendation 2,
                        efforts should be made to remediate these deviations.
                    </li>
                    <li>
                        Strong centralized governance and architectural support
                        are necessary to achieve and maintain the desired
                        outcome.
                    </li>
                    <li>
                        Given the current landscape, full compliance with the
                        hub-and-spoke architecture is aspirational.
                    </li>
                    <li>
                        Architectural principles are provided as guideposts to
                        ensure consistency and health of the hub-and-spoke
                        architecture; the principles are not mandates.
                    </li>
                </ol>
                <p>
                    Learn more about the Upstream Data Foundation
                    <a
                        href="https://wiki.na.xom.com/index.php/Upstream_Data_Foundation"
                        target="_blank"
                        >here.</a
                    >
                </p>
                <br />
                <br />
            </div>
        </div>
        <div class="row">
            <div
                class="col-lg-4 col-md-6"
                *ngFor="let singleProjectsContent of singleProjectsBox"
            >
                <div class="single-projects-box">
                    <div class="image">
                        <img
                            [src]="singleProjectsContent.img"
                            alt="image"
                            [class]="singleProjectsContent.imgClass"
                        />

                        <a
                            [routerLink]="singleProjectsContent.link"
                            class="link-btn"
                        >
                            <i [class]="singleProjectsContent.icon"></i>
                        </a>
                    </div>

                    <div class="content">
                        <h3>
                            <a
                                *ngIf="
                                    singleProjectsContent.link.indexOf('http') <
                                    0
                                "
                                [routerLink]="singleProjectsContent.link"
                                >{{ singleProjectsContent.title }}</a
                            >
                            <a
                                *ngIf="
                                    singleProjectsContent.link.indexOf(
                                        'http'
                                    ) >= 0
                                "
                                [routerLink]="singleProjectsContent.link"
                                target="_blank"
                                [innerHTML]="singleProjectsContent.title"
                            ></a>
                        </h3>
                        <span>{{ singleProjectsContent.subTitle }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
